export enum TicketActionStatusInternal {

   pending,
   started,
   completed,
   cancelled,
   waiting,
   negative_completed
}